"use client";

export interface VehicleDescriptionProps {
  title?: string;
  description: string;
}

export function VehicleDescription({
  title = "Description",
  description,
}: VehicleDescriptionProps) {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold mb-4">{title}</h2>
      <p className="text-muted-foreground leading-relaxed">{description}</p>
    </div>
  );
}
